export default
{
    name: 'app-img',

    props:
    {
        src: { type: String },
        alt: { type: String, default: '' },
        width: { type: String, default: '' },
        height: { type: String, default: '' }
    },

    methods:
    {
        _onLoad(event)
        {
            const el = this.$el
            el.classList.add('is-load')
            this.$emit('load', event)
        }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/components/app-img/script.js